const swiperCol1 = document.querySelector(".reviews-swiper") && new Swiper(".reviews-swiper", {
  slidesPerView: "auto",
  spaceBetween: 20,
  loop: true,
  speed: 3000, // higher = slower (controls linear scroll speed)
  autoplay: {
    delay: 1500, // no delay between slides
  
  },
centeredSlides: true,
 
  grabCursor: true, 
});


const swiperCol2 = document.querySelector(".why-swiper") && new Swiper(".why-swiper", {
  slidesPerView: 1.6,
  spaceBetween: 20,
  grabCursor: true, 
  keyboard: {
    enabled: true
  },
    scrollbar: { el: ".swiper-scrollbar-why", draggable: true },
    navigation: {
      nextEl: ".swiper-button-next-why",
      prevEl: ".swiper-button-prev-why"
    },
    breakpoints: {
      640: { slidesPerView: 1.15, spaceBetween: 15 }
      
    }
});

const swiperCol3 = document.querySelector(".ugc-slider-wrapper") && new Swiper(".ugc-slider-wrapper", {
  slidesPerView: 4.2,
  spaceBetween: 20,
  grabCursor: true, 
    freeMode: true,
    mousewheel: { forceToAxis: true, invert: true },
  keyboard: {
    enabled: true
  },
  
    navigation: {
      nextEl: ".swiper-button-next-ugc",
      prevEl: ".swiper-button-prev-ugc"
    },
    breakpoints: {
      640: { 
         freeMode: false,
        slidesPerView: 1.15, 
        spaceBetween: 15 
      }
      
    }
});


const swiperCol4 = document.querySelector(".new-rev-block-1") && new Swiper(".new-rev-block-1", {
  slidesPerView: 1.4,
  spaceBetween: 20,
  grabCursor: true, 
  keyboard: {
    enabled: true
  },
    scrollbar: { el: ".swiper-scrollbar-rev-1", draggable: true },
    breakpoints: {
      640: { slidesPerView: 1.15, spaceBetween: 15 }
      
    }
});
const swiperCol5 = document.querySelector(".new-rev-block-2") && new Swiper(".new-rev-block-2", {
  slidesPerView: 1.4,
  spaceBetween: 20,
  grabCursor: true, 
  keyboard: {
    enabled: true
  },
    scrollbar: { el: ".swiper-scrollbar-rev-2", draggable: true },
    breakpoints: {
      640: { slidesPerView: 1, spaceBetween: 15 }
      
    }
});



 
 const swiperCol6 = document.querySelector('.press-swiper-section') && new Swiper('.press-swiper-section', {
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next-new',
        prevEl: '.swiper-button-prev-new',
      },
      pagination: {
        el: '.swiper-pagination-new',
        type: 'fraction',
      },
      breakpoints: {
       
        768: {
          slidesPerView: 1,
          spaceBetween: 30,
        }
      }
    });


// Specs accordion — delegated on document so it (a) works no matter when
// wixkraft.js loads, and (b) survives <product-rerender> DOM swaps.
document.addEventListener('click', function (event) {
  const header = event.target.closest('.specs-accordion-header');
  if (!header) return;

  const panel = document.getElementById(header.dataset.target);
  if (!panel) return;

  const toggle = header.querySelector('.specs-toggle');
  const wasOpen = header.classList.contains('specs-active');

  // Only touch accordions in THIS group (its own wrapper), so product / footer /
  // how-it-works / tap-water-effect accordions don't close each other.
  const item = header.closest('.specs-accordion-item');
  const group = item ? item.parentElement : document;

  group.querySelectorAll('.specs-accordion-header.specs-active').forEach(open => {
    open.classList.remove('specs-active');
    const openPanel = document.getElementById(open.dataset.target);
    if (openPanel) openPanel.classList.remove('open');
    const openToggle = open.querySelector('.specs-toggle');
    if (openToggle) openToggle.classList.remove('specs-active');
  });

  // If it was already open, the loop above just closed it (tap-to-close).
  // Otherwise, open it.
  if (!wasOpen) {
    header.classList.add('specs-active');
    panel.classList.add('open');
    if (toggle) toggle.classList.add('specs-active');
  }
});